import { SUN_PALETTES } from '../../shared/palette';
import { INK } from '../face-kit';
import { paint, type Shape } from '../paint';

export const FINE = 3;
export const BOX = { w: 44, h: 56 };
const BODY = '#2b3048';
const RIM = '#c9d2f5';
const YELLOW = '#ffd23f';
const { healer, rouge } = SUN_PALETTES.nuit;

export function paintBox(tripped: boolean): Shape {
  const margin = 4;
  return paint((BOX.w + 2 * margin) * FINE, (BOX.h + 2 * margin) * FINE, BOX.h / 2, (ctx) => {
    ctx.scale(FINE, FINE);
    ctx.translate(-BOX.w / 2, -BOX.h / 2);
    ctx.beginPath();
    ctx.roundRect(0, 0, BOX.w, BOX.h, 5);
    ctx.fillStyle = BODY;
    ctx.fill();
    ctx.lineWidth = 3;
    ctx.strokeStyle = RIM;
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(BOX.w / 2 - 9, 9);
    ctx.lineTo(BOX.w / 2 + 9, 9);
    ctx.lineTo(BOX.w / 2, 25);
    ctx.closePath();
    ctx.fillStyle = YELLOW;
    ctx.fill();
    ctx.lineJoin = 'round';
    ctx.lineWidth = 1.2;
    ctx.strokeStyle = INK;
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(BOX.w / 2 + 1.5, 11);
    ctx.lineTo(BOX.w / 2 - 2.5, 17);
    ctx.lineTo(BOX.w / 2 + 2, 17);
    ctx.lineTo(BOX.w / 2 - 1.5, 23);
    ctx.lineWidth = 1.5;
    ctx.stroke();
    ctx.beginPath();
    ctx.roundRect(BOX.w / 2 - 12, 31, 24, 18, 3);
    ctx.fillStyle = INK;
    ctx.fill();
    ctx.beginPath();
    ctx.roundRect(BOX.w / 2 - 4, tripped ? 40 : 33, 8, 8, 2);
    ctx.fillStyle = tripped ? rouge : healer;
    ctx.fill();
  });
}
